import { render, staticRenderFns } from "./cadastro-disciplina.html?vue&type=template&id=1572449a&scoped=true&"
import script from "./cadastro-disciplina.js?vue&type=script&lang=js&"
export * from "./cadastro-disciplina.js?vue&type=script&lang=js&"
import style0 from "./cadastro-disciplina.css?vue&type=style&index=0&id=1572449a&scoped=true&lang=css&"
import style1 from "@/assets/css/input.css?vue&type=style&index=1&id=1572449a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572449a",
  null
  
)

export default component.exports